<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Promociones</h6>
              <router-link :to="{ name: 'Promotions Create' }" class="btn btn-primary btn-sm">
                Agregar <i class="fa fa-plus ms-1"></i>
              </router-link>
            </div>
            <p class="text-muted text-sm mb-3">
              Descuentos especiales para productos específicos entre fechas. Mientras una promoción está vigente,
              su descuento reemplaza el descuento del producto y el general de la tienda en el catálogo.
            </p>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar..." @input="fetchData(null)" />
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nombre</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descuento</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Vigencia</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Productos</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in page.data" :key="value.id">
                    <td class="align-middle text-sm">
                      <div class="font-weight-bold">{{ value.name }}</div>
                      <div v-if="value.description" class="text-xs text-muted">{{ value.description }}</div>
                    </td>
                    <td class="align-middle text-center text-sm font-weight-bold">{{ formatPct(value.discount_percent) }}%</td>
                    <td class="align-middle text-sm">{{ formatDate(value.starts_at) }} — {{ formatDate(value.ends_at) }}</td>
                    <td class="align-middle text-center text-sm">{{ value.products_count }}</td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm" :class="statusClass(value.status)">{{ value.status }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <a @click="$router.push({ name: 'Promotions Edit', params: { id: value.id } })" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip" data-original-title="Editar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a @click="deleteItem(value.id)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;" data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="page.data && page.data.length === 0">
                    <td colspan="6" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <div class="pagination p-3">
                <a v-for="link in page.links" :key="link.label" class="page-item cursor-pointer"
                  @click="fetchData(link.url)" :disabled="!link.url || link.active"
                  :class="{ 'active': link.label === String(page.current_page) }">
                  <span v-html="link.label"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: "PromotionsTables",
  data() {
    return {
      searchQuery: '',
      perPage: 10,
      page: { data: [], current_page: 1, from: 0, to: 0, total: 0, last_page: 1, prev_page_url: null, next_page_url: null, links: [] },
    };
  },
  mounted() { this.fetchData(null); },
  methods: {
    async fetchData(pageUrl = null) {
      const page = pageUrl ? new URL(pageUrl, window.location.origin).searchParams.get('page') || 1 : 1;
      try {
        const res = await this.$store.dispatch("promotions/getPaginated", { page, per_page: this.perPage, search: this.searchQuery });
        this.page = res.data;
      } catch (e) { console.error(e); }
    },
    formatPct(value) {
      const n = parseFloat(value) || 0;
      return Number.isInteger(n) ? n : n.toFixed(2);
    },
    formatDate(value) {
      if (!value) return '-';
      const [y, m, d] = String(value).substring(0, 10).split('-');
      return `${d}/${m}/${y}`;
    },
    statusClass(status) {
      return {
        vigente: 'bg-gradient-success',
        programada: 'bg-gradient-info',
        finalizada: 'bg-gradient-secondary',
        inactiva: 'bg-gradient-warning',
      }[status] || 'bg-gradient-secondary';
    },
    async deleteItem(id) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
        });
        if (result.isConfirmed) {
          await this.$store.dispatch("promotions/delete", id);
          this.fetchData(null);
          await Swal.fire('Eliminado!', 'Promoción eliminada correctamente.', 'success');
        }
      } catch (e) {
        await Swal.fire({ icon: 'error', title: 'Error', text: e?.data?.message || 'Error al eliminar' });
      }
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

</style>
